import { WHOAMI_SUCCESS, WHOAMI_FAILURE } from '../actions/auth';

const initialState = {
    id: 0
};

export default function whoami(state = initialState, action) {
    switch (action.type) {
        case WHOAMI_SUCCESS:
            return {
                ...state,
                ...action.payload
            };
        case WHOAMI_FAILURE:
            return {
                ...state,
                id: 0
            };
        default:
            return state;
    }
}
